module.exports = __webpack_public_path__ + "img/life-path.42e62f55.png";